var chunkToChildrenMap = {
	"5385": [
		5979,
		1886,
		7747,
		1869,
		875,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};